/* This file is autogenerated, see readme.md for instructions */
import MultiParentSelectedSvgIcon from '@bloomreach/banana-theme/icons/multi-parent-selected.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const MultiParentSelectedIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <MultiParentSelectedSvgIcon />
    </Icon>
  );
});

MultiParentSelectedIcon.displayName = 'MultiParentSelectedIcon';

export default MultiParentSelectedIcon;
